import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-2" }
const _hoisted_2 = { class: "px-3 py-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "d-flex justify-content-between border-top gap-1 pt-2" }

import { ref, reactive, computed, inject, shallowRef, nextTick } from "vue";
  import dayjs from "dayjs";
  import axios from "axios";

  
export default {
  __name: 'WeekdayOpeningHours',
  props: {
    initialValues: {
      type: Object,
      default: () => ({
        entries: [],
      }),
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  const props = __props;

  const minDate = computed(() => dayjs().format("YYYY-MM-DD"));

  const weekdays = [
    { value: "monday", index: 1, label: "Montag" },
    { value: "tuesday", index: 2, label: "Dienstag" },
    { value: "wednesday", index: 3, label: "Mittwoch" },
    { value: "thursday", index: 4, label: "Donnerstag" },
    { value: "friday", index: 5, label: "Freitag" },
    { value: "saturday", index: 6, label: "Samstag" },
    { value: "sunday", index: 7, label: "Sonntag" },
  ];

  const validFrom = ref(
    props.initialValues[0] ? dayjs(props.initialValues[0].validFrom?.date).format("YYYY-MM-DD") : ""
  );

  const shouldDisable = computed(() => !!props.initialValues[0]);
  const formErrors = reactive({});
  const validFromError = ref(null);
  const saveError = ref(null);

  // Initialize formErrors for each day
  weekdays.forEach((day) => {
    formErrors[day.value] = "";
  });

  // Use a shallowRef to prevent deep reactivity
  const selectedDaysState = shallowRef(new Map());

  // Computed property for checking if any days are selected
  const hasSelectedDays = computed(() => (fromDay) => {
    return Array.from(selectedDaysState.value.keys()).some((key) => key.startsWith(`${fromDay}-`));
  });

  // Methods for managing selections
  const isSelectedDay = (fromDay, toDay) => {
    return selectedDaysState.value.get(`${fromDay}-${toDay}`) || false;
  };

  const toggleSelectedDay = (fromDay, toDay, value) => {
    const newMap = new Map(selectedDaysState.value);
    const key = `${fromDay}-${toDay}`;

    if (value) {
      newMap.set(key, true);
    } else {
      newMap.delete(key);
    }

    selectedDaysState.value = newMap;
  };

  const clearSelection = (fromDay) => {
    const newMap = new Map(selectedDaysState.value);
    Array.from(newMap.keys())
      .filter((key) => key.startsWith(`${fromDay}-`))
      .forEach((key) => newMap.delete(key));

    selectedDaysState.value = newMap;
  };

  const copyToSelectedDays = (fromDay) => {
    const updatedHours = { ...hours };

    weekdays.forEach((day) => {
      if (isSelectedDay(fromDay, day.value)) {
        updatedHours[day.value] = {
          id: hours[day.value].id,
          from: hours[fromDay].from,
          to: hours[fromDay].to,
        };
      }
    });

    // Batch update hours
    Object.entries(updatedHours).forEach(([day, value]) => {
      hours[day] = value;
    });

    // Validate after all updates are done
    weekdays.forEach((day) => {
      if (updatedHours[day.value].from && updatedHours[day.value].to) {
        validateTimeInput(day.value);
      }
    });

    clearSelection(fromDay);

    // Close dropdown using nextTick to avoid reactivity issues
    nextTick(() => {
      const dropdownElement = document.querySelector(`[data-day="${fromDay}"]`);
      if (dropdownElement) {
        const toggle = dropdownElement.querySelector(".dropdown-toggle");
        if (toggle) toggle.click();
      }
    });
  };

  const getInitialWeekdayValue = (dayIndex) => {
    const entry = props.initialValues[dayIndex - 1];
    if (!entry) return { from: null, to: null };

    return {
      id: entry.id,
      from: entry.startTime ? dayjs(entry.startTime.date).format("HH:mm") : null,
      to: entry.endTime ? dayjs(entry.endTime.date).format("HH:mm") : null,
    };
  };

  const hours = reactive(
    weekdays.reduce(
      (acc, day) => ({
        ...acc,
        [day.value]: getInitialWeekdayValue(day.index),
      }),
      {}
    )
  );

  // Optimize validation to run less frequently
  const validateTimeInput = (dayValue) => {
    const times = hours[dayValue];
    formErrors[dayValue] = "";

    if (!times.from && !times.to) return true;
    if (!times.from || !times.to) {
      formErrors[dayValue] = "Beide Zeiten müssen gesetzt sein";
      return false;
    }

    const fromTime = new Date(`1970-01-01T${times.from}`);
    const toTime = new Date(`1970-01-01T${times.to}`);

    if (fromTime >= toTime) {
      formErrors[dayValue] = "Endzeit muss nach Startzeit liegen";
      return false;
    }

    return true;
  };

  // Cache validation results
  const isValidDay = computed(() => (day) => {
    const times = hours[day];
    return (!times.from && !times.to) || (times.from && times.to && validateTimeInput(day));
  });

  const saveUrl = inject("saveUrl");
  const onSubmit = async (event) => {
    event.preventDefault();

    saveError.value = null;
    validFromError.value = "";
    let hasErrors = false;

    // Clear all previous errors
    weekdays.forEach((day) => {
      formErrors[day.value] = "";
    });

    // Validate weekday entries with times set
    Object.entries(hours).forEach(([day, times]) => {
      if (times.from || times.to) {
        if (!validateTimeInput(day)) {
          hasErrors = true;
        }
      }
    });

    if (!validFrom.value) {
      validFromError.value = "Bitte geben Sie ein Gültigkeitsdatum an";
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    try {
      const payload = {
        type: "weekdays",
        validFrom: validFrom.value,
        entries: hours,
      };

      await axios.post(saveUrl, payload);
      window.location.reload();
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          saveError.value = error.response.data.error;
        } else {
          saveError.value = "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
        }
      } else {
        saveError.value = "Verbindungsfehler. Bitte überprüfen Sie Ihre Internetverbindung.";
      }
    }
  };

return (_ctx, _cache) => {
  const _component_b_alert = _resolveComponent("b-alert")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_form_group = _resolveComponent("b-form-group")
  const _component_b_form = _resolveComponent("b-form")
  const _component_b_modal = _resolveComponent("b-modal")

  return (_openBlock(), _createBlock(_component_b_modal, {
    id: __props.modalId,
    title: __props.initialValues.length > 0 ? 'Wochenzeiten bearbeiten' : 'Wochenzeiten erstellen',
    "ok-title": "Speichern",
    "cancel-title": "Abbrechen",
    onOk: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_alert, {
        modelValue: saveError.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((saveError).value = $event)),
        variant: "danger"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(saveError.value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_b_form, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (day) => {
            return _createElementVNode("div", {
              key: day.value + __props.modalId,
              class: "mb-2"
            }, [
              _createVNode(_component_b_form_group, {
                label: day.label,
                state: hours[day.value].from || hours[day.value].to ? formErrors[day.value] === '' : null,
                "invalid-feedback": formErrors[day.value]
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_b_form_input, {
                      modelValue: hours[day.value].from,
                      "onUpdate:modelValue": $event => ((hours[day.value].from) = $event),
                      type: "time",
                      placeholder: "Öffnungszeit"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_b_form_input, {
                      modelValue: hours[day.value].to,
                      "onUpdate:modelValue": $event => ((hours[day.value].to) = $event),
                      type: "time",
                      placeholder: "Schließzeit"
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_b_dropdown, {
                      ref_for: true,
                      ref: "dropdown",
                      variant: "outline-secondary",
                      right: "",
                      "menu-class": "w-auto",
                      "data-day": day.value
                    }, {
                      "button-content": _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fas fa-copy" }, null, -1 /* CACHED */)
                      ]))]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (targetDay) => {
                              return _createElementVNode("div", {
                                key: targetDay.value,
                                class: "mb-1",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createVNode(_component_b_form_checkbox, {
                                  "model-value": isSelectedDay(day.value, targetDay.value),
                                  disabled: targetDay.value === day.value,
                                  "onUpdate:modelValue": (value) => toggleSelectedDay(day.value, targetDay.value, value)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(targetDay.label), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "disabled", "onUpdate:modelValue"])
                              ])
                            }), 64 /* STABLE_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_b_button, {
                              size: "sm",
                              variant: "outline-secondary",
                              onClick: $event => (clearSelection(day.value))
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" Zurücksetzen ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _createVNode(_component_b_button, {
                              size: "sm",
                              variant: "primary",
                              disabled: !hasSelectedDays.value(day.value),
                              onClick: $event => (copyToSelectedDays(day.value))
                            }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode(" Kopieren ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                          ])
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-day"])
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "state", "invalid-feedback"])
            ])
          }), 64 /* STABLE_FRAGMENT */)),
          _createVNode(_component_b_form_group, {
            label: "Gültig ab",
            state: validFromError.value === null ? null : validFromError.value === true,
            "invalid-feedback": validFromError.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                modelValue: validFrom.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((validFrom).value = $event)),
                disabled: shouldDisable.value,
                type: "date",
                min: minDate.value,
                required: ""
              }, null, 8 /* PROPS */, ["modelValue", "disabled", "min"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state", "invalid-feedback"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "title"]))
}
}

}